import React, { useState, useEffect } from "react";
import api from "../../api/api";

const BASE_URL = "https://imagensdaface.com.br";
const FALLBACK_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mN8Xw8AAmoBXY99YmUAAAAASUVORK5CYII=";

export default function ProductManagement({ refresh, doRefresh, setNotification }) {
  // --- ESTADOS ---
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [selectedImage, setSelectedImage] = useState(null); // Para o Modal

  const [formData, setFormData] = useState({
    name: "", price: "", old_price: "", description: "", image_url: "", link_purchase: "",
    weight: "0.500", length: "15", height: "15", width: "15"
  });
  const [imageFile, setImageFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  const [regions, setRegions] = useState([]);
  const [showFreightForm, setShowFreightForm] = useState(false);
  const [editingRegionId, setEditingRegionId] = useState(null);
  const [freightData, setFreightData] = useState({
    region_name: "", cep_prefix_start: "", cep_prefix_end: "",
    price_pac: "", price_sedex: "", delivery_time_pac: "5", delivery_time_sedex: "2"
  });

  const formatImageUrl = (path) => {
    if (!path) return FALLBACK_IMAGE;
    if (path.startsWith("http") || path.startsWith("data:")) return path;
    const cleanPath = path.startsWith("/") ? path : `/${path}`;
    return `${BASE_URL}${cleanPath}`;
  };

  const loadAllData = async () => {
    try {
      const [prodRes, shipRes] = await Promise.all([
        api.get("/products"),
        api.get("/admin/shipping-regions")
      ]);
      let pArray = prodRes.data?.products?.products || prodRes.data?.products || prodRes.data || [];
      setProducts(pArray);
      setRegions(Array.isArray(shipRes.data) ? shipRes.data : []);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { loadAllData(); }, [refresh]);

  const handleEdit = (product) => {
    setEditingId(product.id);
    setFormData({ ...product });
    setPreviewUrl(formatImageUrl(product.image_url));
    setShowForm(true);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleProductSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    Object.keys(formData).forEach(key => data.append(key, formData[key]));
    if (imageFile) data.append("image", imageFile);
    try {
      if (editingId) await api.put(`/admin/products/${editingId}`, data);
      else await api.post("/admin/products", data);
      setNotification({ type: "success", message: "Produto salvo!" });
      resetProductForm(); doRefresh();
    } catch (err) { setNotification({ type: "error", message: "Erro ao salvar." }); }
  };

  const resetProductForm = () => {
    setFormData({ name: "", price: "", old_price: "", description: "", image_url: "", link_purchase: "", weight: "0.500", length: "15", height: "15", width: "15" });
    setImageFile(null); setPreviewUrl(null); setEditingId(null); setShowForm(false);
  };

  const handleFreightSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingRegionId) await api.put(`/admin/shipping-regions/${editingRegionId}`, freightData);
      else await api.post("/admin/shipping-regions", freightData);
      setNotification({ type: "success", message: "Frete salvo!" });
      setShowFreightForm(false); setEditingRegionId(null); loadAllData();
    } catch (err) { setNotification({ type: "error", message: "Erro no frete." }); }
  };

  return (
    <div className="p-4 md:p-0 space-y-10 animate-fadeIn">
      
      {/* MODAL DE IMAGEM */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/80 z-[999] flex items-center justify-center p-4" onClick={() => setSelectedImage(null)}>
          <img src={selectedImage} className="max-w-full max-h-full rounded-lg shadow-2xl animate-zoomIn" alt="Preview" />
          <button className="absolute top-5 right-5 text-white text-3xl font-bold">✕</button>
        </div>
      )}

      {/* GESTÃO DE PRODUTOS */}
      <section>
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Gerenciar Loja</h2>
          <button onClick={() => (showForm ? resetProductForm() : setShowForm(true))} className={`${showForm ? "bg-gray-500" : "bg-emerald-600"} text-white px-4 py-2 rounded-xl font-bold shadow-md transition-all active:scale-95`}>
            {showForm ? "✕ Cancelar" : "+ Novo Produto"}
          </button>
        </div>

        {showForm && (
          <form onSubmit={handleProductSubmit} className="bg-white p-6 rounded-2xl mb-8 border-2 border-emerald-100 shadow-sm animate-slideDown">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="flex flex-col gap-1">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Nome do Produto</label>
                <input type="text" className="p-2 border rounded-lg focus:ring-2 focus:ring-emerald-500 outline-none" value={formData.name} onChange={(e) => setFormData({ ...formData, name: e.target.value })} required />
              </div>

              <div className="flex flex-col gap-1">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Imagem do Produto</label>
                <div className="flex gap-2">
                  <div className="w-10 h-10 border rounded overflow-hidden flex-shrink-0 bg-gray-50 cursor-pointer" onClick={() => setSelectedImage(previewUrl)}>
                    <img src={previewUrl || FALLBACK_IMAGE} className="w-full h-full object-cover" alt="Preview" />
                  </div>
                  <input type="file" onChange={(e) => { const file = e.target.files[0]; if(file){ setImageFile(file); setPreviewUrl(URL.createObjectURL(file)); } }} className="p-1 border rounded-lg text-xs w-full" />
                </div>
              </div>

              <div className="flex flex-col gap-1">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Preço de Venda</label>
                <input type="number" step="0.01" className="p-2 border rounded-lg" value={formData.price} onChange={(e) => setFormData({ ...formData, price: e.target.value })} required />
              </div>

              <div className="flex flex-col gap-1">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Preço Antigo (Riscar)</label>
                <input type="number" step="0.01" className="p-2 border rounded-lg" value={formData.old_price} onChange={(e) => setFormData({ ...formData, old_price: e.target.value })} />
              </div>
              
              <div className="md:col-span-2 grid grid-cols-4 gap-2 bg-emerald-50 p-3 rounded-lg border border-emerald-100">
                <div className="flex flex-col"><label className="text-[9px] font-bold text-emerald-700">PESO (KG)</label><input type="number" step="0.001" value={formData.weight} onChange={e => setFormData({...formData, weight: e.target.value})} className="p-1 border rounded" /></div>
                <div className="flex flex-col"><label className="text-[9px] font-bold text-emerald-700">COMP (CM)</label><input type="number" value={formData.length} onChange={e => setFormData({...formData, length: e.target.value})} className="p-1 border rounded" /></div>
                <div className="flex flex-col"><label className="text-[9px] font-bold text-emerald-700">ALT (CM)</label><input type="number" value={formData.height} onChange={e => setFormData({...formData, height: e.target.value})} className="p-1 border rounded" /></div>
                <div className="flex flex-col"><label className="text-[9px] font-bold text-emerald-700">LARG (CM)</label><input type="number" value={formData.width} onChange={e => setFormData({...formData, width: e.target.value})} className="p-1 border rounded" /></div>
              </div>

              <div className="md:col-span-2 flex flex-col gap-1">
                <label className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Descrição</label>
                <textarea rows="2" className="p-2 border rounded-lg" value={formData.description} onChange={(e) => setFormData({ ...formData, description: e.target.value })} />
              </div>
            </div>
            <button className="w-full mt-4 bg-emerald-600 text-white py-3 rounded-xl font-black shadow-lg hover:bg-emerald-700 transition-all uppercase tracking-tighter">
              {editingId ? "💾 Atualizar Produto" : "🚀 Publicar na Loja"}
            </button>
          </form>
        )}

        <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">
          <table className="w-full text-left">
            <thead className="bg-gray-50 text-[10px] uppercase text-gray-400 border-b">
              <tr><th className="p-4">Produto</th><th className="p-4">Logística</th><th className="p-4">Preço</th><th className="p-4 text-right">Ações</th></tr>
            </thead>
            <tbody>
              {products.map((p) => (
                <tr key={p.id} className="border-b text-sm hover:bg-gray-50 transition-colors">
                  <td className="p-4 flex items-center gap-3">
                    <img src={formatImageUrl(p.image_url)} className="w-12 h-12 rounded border object-cover cursor-pointer" onClick={() => setSelectedImage(formatImageUrl(p.image_url))} onError={(e)=>e.target.src=FALLBACK_IMAGE} />
                    <span className="font-bold text-gray-700">{p.name}</span>
                  </td>
                  <td className="p-4 text-[10px] text-gray-400">{p.weight}kg | {p.length}x{p.height}x{p.width}cm</td>
                  <td className="p-4 font-bold text-emerald-600">R$ {p.price}</td>
                  <td className="p-4 text-right">
                    <button onClick={() => handleEdit(p)} className="p-2 text-blue-500 hover:bg-blue-50 rounded-lg">✏️</button>
                    <button onClick={async () => { if(window.confirm("Excluir?")){ await api.delete(`/admin/products/${p.id}`); doRefresh(); } }} className="p-2 text-red-500 hover:bg-red-50 rounded-lg">🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      {/* GESTÃO DE FRETE */}
      <section className="bg-white p-6 rounded-3xl border border-gray-200 shadow-sm">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold text-emerald-800">Tabela de Frete Regional</h2>
          <button onClick={() => setShowFreightForm(!showFreightForm)} className="bg-emerald-700 text-white px-4 py-2 rounded-xl text-xs font-black uppercase shadow-md transition-all active:scale-95">
            {showFreightForm ? "✕ Fechar" : "+ Região"}
          </button>
        </div>

        {showFreightForm && (
          <form onSubmit={handleFreightSubmit} className="bg-gray-50 p-6 rounded-2xl border-2 border-emerald-50 mb-6 animate-slideDown">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
              <div className="flex flex-col gap-1">
                <label className="text-[10px] font-black text-emerald-700 uppercase">Descrição da Região</label>
                <input placeholder="Ex: São Paulo (Capital)" className="p-2 border rounded-lg bg-white" value={freightData.region_name} onChange={e => setFreightData({...freightData, region_name: e.target.value})} required />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-[10px] font-black text-emerald-700 uppercase">CEP Início (Prefixo)</label>
                <input type="number" placeholder="Ex: 01" className="p-2 border rounded-lg bg-white" value={freightData.cep_prefix_start} onChange={e => setFreightData({...freightData, cep_prefix_start: e.target.value})} required />
              </div>
              <div className="flex flex-col gap-1">
                <label className="text-[10px] font-black text-emerald-700 uppercase">CEP Fim (Prefixo)</label>
                <input type="number" placeholder="Ex: 19" className="p-2 border rounded-lg bg-white" value={freightData.cep_prefix_end} onChange={e => setFreightData({...freightData, cep_prefix_end: e.target.value})} required />
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div className="p-4 bg-white rounded-xl border flex flex-col gap-2">
                <span className="text-[10px] font-black text-emerald-600 border-b pb-1">SERVIÇO PAC</span>
                <div className="flex gap-2">
                  <div className="w-1/2">
                    <label className="text-[9px] text-gray-400 block">VALOR (R$)</label>
                    <input type="number" step="0.01" className="w-full p-2 border rounded" value={freightData.price_pac} onChange={e => setFreightData({...freightData, price_pac: e.target.value})} required />
                  </div>
                  <div className="w-1/2">
                    <label className="text-[9px] text-gray-400 block">DIAS</label>
                    <input type="number" className="w-full p-2 border rounded" value={freightData.delivery_time_pac} onChange={e => setFreightData({...freightData, delivery_time_pac: e.target.value})} required />
                  </div>
                </div>
              </div>

              <div className="p-4 bg-white rounded-xl border flex flex-col gap-2">
                <span className="text-[10px] font-black text-blue-600 border-b pb-1">SERVIÇO SEDEX</span>
                <div className="flex gap-2">
                  <div className="w-1/2">
                    <label className="text-[9px] text-gray-400 block">VALOR (R$)</label>
                    <input type="number" step="0.01" className="w-full p-2 border rounded" value={freightData.price_sedex} onChange={e => setFreightData({...freightData, price_sedex: e.target.value})} required />
                  </div>
                  <div className="w-1/2">
                    <label className="text-[9px] text-gray-400 block">DIAS</label>
                    <input type="number" className="w-full p-2 border rounded" value={freightData.delivery_time_sedex} onChange={e => setFreightData({...freightData, delivery_time_sedex: e.target.value})} required />
                  </div>
                </div>
              </div>
            </div>

            <button className="w-full mt-6 bg-emerald-600 text-white py-3 rounded-xl font-black uppercase shadow-lg hover:bg-emerald-700 transition-all">
              {editingRegionId ? "💾 Atualizar Tabela" : "🚀 Salvar Nova Região"}
            </button>
          </form>
        )}

        <div className="bg-white rounded-2xl border overflow-hidden">
          <table className="w-full text-left text-sm">
            <thead className="bg-gray-50 text-[10px] text-gray-400 uppercase">
              <tr><th className="p-4">Região / Faixa</th><th className="p-4">PAC</th><th className="p-4">SEDEX</th><th className="p-4 text-right">Ações</th></tr>
            </thead>
            <tbody>
              {regions.map(r => (
                <tr key={r.id} className="border-b hover:bg-gray-50 transition-colors">
                  <td className="p-4">
                    <div className="font-bold text-gray-700">{r.region_name}</div>
                    <div className="text-[10px] text-gray-400 font-mono">Faixa: {String(r.cep_prefix_start).padStart(2,'0')} até {String(r.cep_prefix_end).padStart(2,'0')}</div>
                  </td>
                  <td className="p-4">
                    <span className="text-emerald-600 font-bold">R$ {r.price_pac}</span>
                    <span className="text-[10px] text-gray-300 ml-1">{r.delivery_time_pac}d</span>
                  </td>
                  <td className="p-4">
                    <span className="text-blue-600 font-bold">R$ {r.price_sedex}</span>
                    <span className="text-[10px] text-gray-300 ml-1">{r.delivery_time_sedex}d</span>
                  </td>
                  <td className="p-4 text-right">
                    <button onClick={() => { setEditingRegionId(r.id); setFreightData(r); setShowFreightForm(true); }} className="p-2 text-blue-500">✏️</button>
                    <button onClick={async () => { if(window.confirm("Remover frete?")){ await api.delete(`/admin/shipping-regions/${r.id}`); loadAllData(); } }} className="p-2 text-red-500">🗑️</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}